import { render, staticRenderFns } from "./expense-bill-paid.vue?vue&type=template&id=05c85d00&"
import script from "./expense-bill-paid.js?vue&type=script&lang=js&"
export * from "./expense-bill-paid.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports